import { AddStockGroupPayloadType } from "../../../../../commonTypes/clientSettingsTypes";
import { TableHeadersType } from "../../../../../constant/tableHeadersConstants/tableHeadersType";
import {  formateDateWithTime } from "../../../../../utils/commonFunctions";
import UpdatedByAndUpdatedAt from "../../../../commons/CommonUpdatedByAndUpdatedAt";

type AppProps = {
  menuDetails: any;
  handleEditStockGroupDetails: (data: AddStockGroupPayloadType) => void;
  headers: TableHeadersType[];
  isEditStockGroupPresent?:boolean;
};
const NormalTable = ({
  menuDetails,
  handleEditStockGroupDetails,
  headers,
  isEditStockGroupPresent
}: AppProps) => {
  const renderTableData = () => {
    
    return (
      <tr>
        {headers?.length &&
          headers?.map((header: TableHeadersType) => {
            if (header.value === "stock_group_id") {
              return (
                <td className="text-start">
                  <span>{menuDetails?.stock_group_id}</span>
                </td>
              );
            } else if (header.value === "stock_group_name") {
              return (
                <td>
                  <span>{menuDetails?.stock_group_name}</span>
                </td>
              );
            }
            else if (header.value === "Parent Account") {
              return (
                <td className="text-start">
                </td>
              );
            }
            else if (header.value === "updated_at") {
              return (
                <td>
                   <UpdatedByAndUpdatedAt
            firstName={menuDetails?.updated_by?.first_name}
            lastName={menuDetails?.updated_by?.last_name}
            profilePic={menuDetails?.updated_by?.profile_pic?.file_url}
            updatedAt={formateDateWithTime(menuDetails?.updated_at)}
          />
                </td>
              );
            }
          })}
        <td style={{ width: "80px", textAlign: "center" }}>
      {isEditStockGroupPresent && <span
            className="d-inline-block pointer"
            onClick={() => handleEditStockGroupDetails(menuDetails)}
          >
            <div
              style={{
                color: "#d43",
                fontSize: 20,
              }}
            >
              <i className="fas fa-pen"></i>
            </div>
          </span>}
        </td>
      </tr>
    );
  };
  return <>{renderTableData()}</>;
};
export default NormalTable;
